import { render, staticRenderFns } from "./ExpressCheckin.vue?vue&type=template&id=56afb78c&scoped=true&"
import script from "./ExpressCheckin.vue?vue&type=script&lang=js&"
export * from "./ExpressCheckin.vue?vue&type=script&lang=js&"
import style0 from "./ExpressCheckin.vue?vue&type=style&index=0&id=56afb78c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56afb78c",
  null
  
)

export default component.exports